import { render } from "./SendUpdatesBox.vue?vue&type=template&id=7e7d3014&ts=true"
import script from "./SendUpdatesBox.vue?vue&type=script&lang=ts"
export * from "./SendUpdatesBox.vue?vue&type=script&lang=ts"

import "./SendUpdatesBox.vue?vue&type=style&index=0&id=7e7d3014&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__